/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerMemo } from '../../models/customer-memo';

export interface UpdateCustomerMemo$Params {
      body: CustomerMemo
}

export function updateCustomerMemo(http: HttpClient, rootUrl: string, params: UpdateCustomerMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerMemo>> {
  const rb = new RequestBuilder(rootUrl, updateCustomerMemo.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerMemo>;
    })
  );
}

updateCustomerMemo.PATH = '/customermemo';
